import type {Department, Employee} from "./types.ts";
import {computed, type ComputedRef, ref, type Ref} from "vue";
import EmployeeSlider from "./components/EmployeeSlider.vue";

export default class EmployeeProvider {

    protected activeLocation: Ref<undefined | Location> = ref(undefined);
    protected activeDepartment: Ref<undefined | Department> = ref(undefined);

    protected filteredDepartments: ComputedRef<Array<Department>>;
    protected activeEmployeesId: ComputedRef<Array<number>>;

    constructor(
        protected employees: Array<Employee>,
        protected departments: Array<Department>,
        protected locations: Array<Location>
    ) {

        this.filteredDepartments = computed(() => {
            if(!this.activeLocation.value) {
                return this.departments;
            }

            // get departments from filtered employees
            const departmentsFilter = this.employees
                .filter(employee => {
                    return employee.locations.includes(this.activeLocation.value?.id);
                })
                .reduce((departments: Array<number>, employee) => {
                    for (const department of employee.departments) {
                        if (!departments.includes(department)) {
                            departments.push(department);
                        }
                    }
                    return departments;
                }, []);

            return this.departments.filter(department => departmentsFilter.includes(department.id));
        });

        this.activeEmployeesId = computed(() => {
            const active: Array<number> = [];

            this.employees.forEach(employee => {
                if (
                    (!this.activeLocation.value || (this.activeLocation.value && employee.locations.includes(this.activeLocation.value.id))) &&
                    (!this.activeDepartment.value || (this.activeDepartment.value && employee.departments.includes(this.activeDepartment.value.id)))
                ) {
                    active.push(employee.id);
                }
            });

            return active;
        });
    }

    public getLocations(): Array<Location> {
        return this.locations;
    }

    public getActiveLocationRef(): Ref<Location> {
        return this.activeLocation;
    }

    public getFilteredDepartmentsComputed() {
        return this.filteredDepartments;
    }

    public getActiveDepartmentRef() {
        return this.activeDepartment;
    }

    public getEmployees() {
        return this.employees;
    }

    public getActiveEmployeesIdComputed() {
        return this.activeEmployeesId;
    }

}
